/**
 * Pandectes region controller (vendor how-to, 86cbb3cwf).
 *
 * Shows the cookie notice only in "strict" regions (EU/UK, Australia, and
 * the 19 US privacy-law states). In non-law US states the banner stays
 * hidden but Your Privacy Choices still opens preferences via
 * Pandectes.openDialog — the app #reopenBanner hook does not fire when
 * the banner is not in play for that region. Non-US regions we do not
 * list are left to the app's own geo rules. A stored Accept/Decline
 * (_pandectes_gdpr) is always respected: the notice is only auto-opened
 * when no choice has been recorded yet.
 *
 * Shopify.customerPrivacy.getRegion() is "US-CA", "DE", "GB", etc.
 * US states MUST be prefixed US- (bare CA/IN collide with Canada/India).
 */
(function () {
  var VERSION = "pandectes-region-controller-2026-09-10-final";
  var STRICT_REGION_PREFIXES = [
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
    "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
    "PL", "PT", "RO", "SK", "SI", "ES", "SE", "NO", "IS", "LI",
    "CH", "GB",
    "AU",
    "US-CA", "US-CO", "US-CT", "US-DE", "US-FL", "US-IN", "US-IA",
    "US-KY", "US-MN", "US-MT", "US-NE", "US-NH", "US-NJ", "US-OR",
    "US-RI", "US-TN", "US-TX", "US-UT", "US-VA"
  ];
  var REOPEN_SELECTOR = [
    'a[href="#reopenBanner"]',
    'a[href*="#reopenBanner"]',
    '[data-pandectes-reopen="preferences"]',
    "[data-pandectes-reopen]"
  ].join(",");

  var strictNoticeOpened = false;
  var initialized = false;
  var preferencesOpenedByUser = false;
  var nonLawGuardInterval = null;

  function log() {
    try {
      console.log.apply(console, ["[Pandectes Region Controller]"].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function getPandectes() {
    return window.Pandectes && typeof window.Pandectes.openDialog === "function"
      ? window.Pandectes
      : null;
  }

  function getRegion() {
    try {
      if (
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.getRegion === "function"
      ) {
        var raw = String(Shopify.customerPrivacy.getRegion() || "").toUpperCase();
        if (/^US[A-Z]{2}$/.test(raw)) return "US-" + raw.slice(2);
        return raw;
      }
    } catch (e) {}
    return "";
  }

  function isStrictRegion(region) {
    if (!region) return false;
    for (var i = 0; i < STRICT_REGION_PREFIXES.length; i++) {
      if (region.indexOf(STRICT_REGION_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  // Empty or country-only "US" is not enough to tell CA from AZ.
  // Closing the dialog in that window is what made the CA banner flash.
  function isRegionReady(region) {
    if (!region) return false;
    if (region === "US") return false;
    return true;
  }

  function currentConsent() {
    var api = getPandectes();
    if (!api || typeof api.currentVisitorConsent !== "function") return null;
    try {
      return api.currentVisitorConsent();
    } catch (e) {
      return null;
    }
  }

  // The app stores consent as base64 JSON in the _pandectes_gdpr cookie
  // (localStorage fallback) — the same record pandectes-rules.js reads.
  // A non-null "preferences" key means the visitor already chose. This is
  // readable synchronously on every page load, unlike the API, which may
  // not be initialised yet when we decide (that race re-showed the banner
  // after Accept/Decline).
  function readStoredConsent() {
    var raw = null;
    try {
      var cookies = document.cookie.split("; ");
      for (var i = 0; i < cookies.length; i++) {
        if (cookies[i].indexOf("_pandectes_gdpr=") === 0) {
          raw = cookies[i].slice("_pandectes_gdpr=".length);
          break;
        }
      }
      if (!raw) {
        raw = window.localStorage.getItem("_pandectes_gdpr");
      }
      if (!raw) return null;
      var data = JSON.parse(window.atob(raw));
      return data && data.preferences != null ? data : null;
    } catch (e) {
      return null;
    }
  }

  function hasVisitorMadeChoice() {
    if (readStoredConsent()) return true;

    var consent = currentConsent();
    if (!consent) return false;

    // The API answers with booleans on some app versions and "yes"/"no"
    // strings on others — accept both.
    function answered(value) {
      return (
        value === true || value === false || value === "yes" || value === "no"
      );
    }

    return (
      answered(consent.preferences) ||
      answered(consent.analytics) ||
      answered(consent.marketing)
    );
  }

  function revealCmp() {
    var style = document.getElementById("pandectes-cmp-prehide");
    if (style) style.remove();
  }

  function openPreferences() {
    preferencesOpenedByUser = true;
    var api = getPandectes();
    if (!api) return false;
    revealCmp();
    api.openDialog("preferences");
    setTimeout(hideWidgetEverywhere, 0);
    setTimeout(hideWidgetEverywhere, 200);
    return true;
  }

  function retryOpenPreferences() {
    preferencesOpenedByUser = true;
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts++;
      if (openPreferences() || attempts >= 40) {
        window.clearInterval(interval);
      }
    }, 250);
  }

  function openNotice() {
    var api = getPandectes();
    if (!api) return false;
    revealCmp();
    api.openDialog("notice");
    setTimeout(hideWidgetEverywhere, 0);
    setTimeout(hideWidgetEverywhere, 200);
    return true;
  }

  function closeDialog() {
    var api = getPandectes();
    if (!api || typeof api.closeDialog !== "function") return false;
    api.closeDialog();
    setTimeout(hideWidgetEverywhere, 0);
    return true;
  }

  function ensureDocumentStyle() {
    if (document.getElementById("pandectes-region-controller-style")) return;

    var style = document.createElement("style");
    style.id = "pandectes-region-controller-style";
    style.textContent = [
      '[data-pandectes-region-hidden="true"] {',
      "  display: none !important;",
      "  visibility: hidden !important;",
      "  opacity: 0 !important;",
      "  pointer-events: none !important;",
      "}"
    ].join("\n");
    document.head.appendChild(style);
  }

  function markHidden(el) {
    if (!el || el.nodeType !== 1) return;
    el.setAttribute("data-pandectes-region-hidden", "true");
    el.style.setProperty("display", "none", "important");
    el.style.setProperty("visibility", "hidden", "important");
    el.style.setProperty("opacity", "0", "important");
    el.style.setProperty("pointer-events", "none", "important");
  }

  function isLikelyStatusWidget(el) {
    if (!el || el.nodeType !== 1) return false;

    var text = String(el.textContent || "").trim().toLowerCase();
    var aria = String(el.getAttribute("aria-label") || "").toLowerCase();
    var dataRole = String(el.getAttribute("data-role") || "").toLowerCase();
    var dataDialog = String(el.getAttribute("data-dialog") || "").toLowerCase();
    var part = String(el.getAttribute("part") || "").toLowerCase();
    var cls = String(el.className || "").toLowerCase();
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (e) {
      rect = null;
    }

    if (dataRole === "status" || dataDialog === "status") return true;
    if (part.indexOf("status") !== -1) return true;

    var mentionsStatus =
      aria.indexOf("cookie") !== -1 ||
      aria.indexOf("privacy") !== -1 ||
      cls.indexOf("status") !== -1 ||
      cls.indexOf("floating") !== -1 ||
      cls.indexOf("reopen") !== -1 ||
      cls.indexOf("widget") !== -1 ||
      text === "cookie" ||
      text === "cookies" ||
      text === "cookie settings";

    var looksFloating =
      rect &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.width <= 180 &&
      rect.height <= 180 &&
      rect.left < 220 &&
      (window.innerHeight - rect.bottom) < 220;

    return mentionsStatus && looksFloating;
  }

  function inspectRoot(root) {
    if (!root || typeof root.querySelectorAll !== "function") return 0;

    var count = 0;
    var all = root.querySelectorAll("*");

    for (var i = 0; i < all.length; i++) {
      if (isLikelyStatusWidget(all[i])) {
        markHidden(all[i]);
        count++;
      }
    }

    return count;
  }

  function hideWidgetEverywhere() {
    ensureDocumentStyle();

    var total = 0;
    var hosts = document.querySelectorAll("pandectes-cmp");

    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      total += inspectRoot(host);

      if (host.shadowRoot) {
        total += inspectRoot(host.shadowRoot);
      }
    }

    return total;
  }

  function applyRegionalBehavior(source) {
    var api = getPandectes();
    if (!api) return false;

    var region = getRegion();
    var ready = isRegionReady(region);
    var strict = isStrictRegion(region);
    var madeChoice = hasVisitorMadeChoice();

    log("VERSION:", VERSION);
    log("Source:", source);
    log("Detected Shopify region:", region || "(empty)");
    log("Region ready:", ready);
    log("Strict region:", strict);
    log("Visitor has made choice:", madeChoice);
    log("Preferences opened by user:", preferencesOpenedByUser);

    hideWidgetEverywhere();

    // Do not auto-close after the visitor asked for the preference centre.
    if (preferencesOpenedByUser) {
      hideWidgetEverywhere();
      return true;
    }

    // Wait for a real region. Closing here is the CA flash.
    if (!ready) {
      log("Skip open/close until Shopify region is known");
      return false;
    }

    if (strict) {
      revealCmp();
      if (!madeChoice && !strictNoticeOpened) {
        strictNoticeOpened = true;
        openNotice();
      }
    } else if (region.indexOf("US-") === 0) {
      // US state without a privacy law: keep the banner out of the way.
      // Host stays pre-hidden; the footer link reveals it on demand.
      closeDialog();
      startNonLawGuard();
    } else {
      // Non-US region we do not list (e.g. NZ, CA-Canada): leave the app's
      // own geo rules in charge, but lift the pre-hide so it can show.
      revealCmp();
      log("Non-US region not in list; leaving app default");
    }

    hideWidgetEverywhere();
    return true;
  }

  function bindReopenLinks() {
    document.addEventListener(
      "click",
      function (event) {
        var trigger = null;
        try {
          trigger = event.target.closest(REOPEN_SELECTOR);
        } catch (e) {
          trigger = null;
        }

        if (!trigger) return;

        event.preventDefault();
        var opened = openPreferences();
        if (opened) {
          event.stopPropagation();
          return;
        }
        // API not ready yet (common when the banner never showed).
        // Let the footer hash handler run and keep retrying openDialog.
        retryOpenPreferences();
      },
      true
    );

    window.addEventListener("hashchange", function () {
      if (window.location.hash === "#reopenBanner") {
        openPreferences();
      }
    });

    if (window.location.hash === "#reopenBanner") {
      setTimeout(openPreferences, 50);
    }
  }


  function startNonLawGuard() {
    if (nonLawGuardInterval) return;
    nonLawGuardInterval = window.setInterval(function () {
      if (preferencesOpenedByUser) return;
      closeDialog();
      hideWidgetEverywhere();
    }, 500);
  }

  function suppressLateNonLawNotice(attempt) {
    if (preferencesOpenedByUser) return;

    var region = getRegion();
    if (!isRegionReady(region)) {
      if ((attempt || 0) < 5) {
        setTimeout(function () {
          suppressLateNonLawNotice((attempt || 0) + 1);
        }, 500);
      }
      return;
    }
    if (isStrictRegion(region)) return;
    if (region.indexOf("US-") !== 0) return;

    log("Closing late-shown notice in non-law US state:", region);
    closeDialog();
  }

  function bindPandectesEvents() {
    document.addEventListener("PandectesInitialized", function () {
      applyRegionalBehavior("PandectesInitialized");
    });
    document.addEventListener("PandectesDialogOpened", function () {
      hideWidgetEverywhere();
      suppressLateNonLawNotice(0);
    });
    document.addEventListener("PandectesDialogClosed", hideWidgetEverywhere);
    document.addEventListener("PandectesButtonClicked", hideWidgetEverywhere);
    document.addEventListener("PandectesConsentUpdate", hideWidgetEverywhere);
  }

  function startPolling() {
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts++;
      hideWidgetEverywhere();

      if (getPandectes() && applyRegionalBehavior("polling")) {
        window.clearInterval(interval);
        return;
      }

      if (attempts >= 120) {
        window.clearInterval(interval);
        revealCmp();
        log("Region never resolved; leaving app default");
      }
    }, 250);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    bindReopenLinks();
    bindPandectesEvents();
    hideWidgetEverywhere();

    if (getPandectes()) {
      if (!applyRegionalBehavior("immediate")) {
        startPolling();
      }
    } else {
      startPolling();
    }

    log("Loaded:", VERSION);
  }

  window.OOConsentRegionControllerVersion = VERSION;
  window.OOConsentRegionControllerTest = function () {
    return applyRegionalBehavior("manual-test");
  };
  window.OOConsentRegionHideWidget = function () {
    return hideWidgetEverywhere();
  };
  window.OOConsentRegionOpenPreferences = function () {
    return openPreferences();
  };
  window.OOConsentRegionOpenNotice = function () {
    return openNotice();
  };
  window.OOConsentRegionDebugVisiblePandectesElements = function () {
    var result = [];
    var hosts = document.querySelectorAll("pandectes-cmp");

    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var roots = [host];
      if (host.shadowRoot) roots.push(host.shadowRoot);

      for (var r = 0; r < roots.length; r++) {
        var root = roots[r];
        if (!root.querySelectorAll) continue;

        var nodes = root.querySelectorAll("*");
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          var rect = el.getBoundingClientRect();
          if (rect.width <= 0 && rect.height <= 0) continue;

          result.push({
            tag: el.tagName.toLowerCase(),
            role: el.getAttribute("role"),
            dataRole: el.getAttribute("data-role"),
            dataDialog: el.getAttribute("data-dialog"),
            ariaLabel: el.getAttribute("aria-label"),
            part: el.getAttribute("part"),
            className: String(el.className || ""),
            text: String(el.textContent || "").trim().slice(0, 100),
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            left: Math.round(rect.left),
            top: Math.round(rect.top)
          });
        }
      }
    }

    return result;
  };

  init();
})();
